import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import qs from 'qs';
import ContentSection from '../ContentSection';
import NavbarDropdown from './NavbarDropdown';
import NavbarLink from './NavbarLink';

import './styles.css';
import mcguireBassLogo from './jaguar-bass-logo.png';

export default class Navbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsedMenuDropdownOpen: false,
      productsDropdownOpen: false
    };
  }

  render() {
    return (
      <div>
        <ContentSection className={`navbar-container ${this.state.collapsedMenuDropdownOpen || this.state.productsDropdownOpen ? 'nav-left-menu-open' : ''}`}>
          <div className="navbar">
              <Link to="/">
                <img className="mcguire-logo" src={mcguireBassLogo} alt="McGuire Music and Sound"/>
              </Link>
              <div className="nav-menu">
                <div className="navbar-uncollapsed-links">
                  {
                    this._navbarLinks.map(l => (
                      <div className="navbar-uncollapsed-link" key={l.title}>
                        <NavbarLink title={l.title} route={l.route} onClick={l.onClick} active={this._isRouteActive(l.route)}/>
                      </div>
                    ))
                  }
                </div>
                {this.state.productsDropdownOpen && <NavbarDropdown className="nav-products-dropdown" items={this._productLinks} onDismissed={this._toggleProductsMenuDropdown}/>}
              </div>
              <div className="nav-collapsed-menu">
                <div className="nav-menu-icon" onClick={this._toggleCollapsedMenuDropdown}>
                  <div className="nav-menu-icon-bar"/>
                  <div className="nav-menu-icon-bar"/>
                  <div className="nav-menu-icon-bar"/>
                </div>
                {this.state.collapsedMenuDropdownOpen && <NavbarDropdown items={this._navbarLinks} onDismissed={this._toggleCollapsedMenuDropdown}/>}
                {this.state.productsDropdownOpen && <NavbarDropdown className="nav-products-dropdown" items={this._productLinks} onDismissed={this._toggleProductsMenuDropdown}/>}
              </div>
          </div>
        </ContentSection>
        <div>
          {this.props.children}
        </div>
      </div>
    );
  }

  _isRouteActive = (route) => {
    const isActive =  this.props.location.pathname === route.split('?')[0];
    return isActive;
  }

  get _navbarLinks() {
    return [
    //   {
    //     title: 'Products',
    //     onClick: this._toggleProductsMenuDropdown,
    //     route: '/products'
    //   },
      {
        title: 'Home',
        route: '/'
      },
      {
        title: 'Lessons',
        route: '/lessons'
      },
      {
        title: 'Repair',
        route: '/repair'
      },
      {
        title: 'Store Info',
        route: '/hours'
      }
    ];
  }

  get _productLinks() {
    return [
      {
        title: 'Guitars & Basses',
        route: `/products?${qs.stringify({ category: 'Guitars & Basses', pageNumber: 1 })}`,
        className: 'product-category-level-0'
      },
      {
        title: 'Acoustic Guitars',
        route: `/products?${qs.stringify({ category: 'Acoustic Guitars', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Electric Guitars',
        route: `/products?${qs.stringify({ category: 'Electric Guitars', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Bass Guitars',
        route: `/products?${qs.stringify({ category: 'Bass Guitars', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Folk Instruments',
        route: `/products?${qs.stringify({ category: 'Folk Instruments', pageNumber: 1 })}`,
        className: 'product-category-level-0'
      },
      {
        title: 'Ukuleles',
        route: `/products?${qs.stringify({ category: 'Ukuleles', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Banjos',
        route: `/products?${qs.stringify({ category: 'Banjos', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Mandolins',
        route: `/products?${qs.stringify({ category: 'Mandolins', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Violins',
        route: `/products?${qs.stringify({ category: 'Violins', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Drums & Percussion',
        route: '/drums',
        className: 'product-category-level-0'
      },
      {
        title: 'Drums Sets',
        route: '/drums',
        className: 'product-category-level-1'
      },
      {
        title: 'Amps',
        route: `/products?${qs.stringify({ category: 'Amps', pageNumber: 1 })}`,
        className: 'product-category-level-0'
      },
      {
        title: 'Guitar Amps',
        route: `/products?${qs.stringify({ category: 'Guitar Amps', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Tube Amps',
        route: `/products?${qs.stringify({ category: 'Tube Amps', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'Bass Amps',
        route: `/products?${qs.stringify({ category: 'Bass Amps', pageNumber: 1 })}`,
        className: 'product-category-level-1'
      },
      {
        title: 'PA & Recording',
        route: '/audio',
        className: 'product-category-level-0'
      },
      {
        title: 'Microphones',
        route: `/products?${qs.stringify({ category: 'Microphones', pageNumber: 1 })}`,
        className: 'product-category-level-0'
      }
    ];
  }

  _toggleCollapsedMenuDropdown = () => {

    this.setState({ collapsedMenuDropdownOpen: !this.state.collapsedMenuDropdownOpen });
  }

  _toggleProductsMenuDropdown = () => {

    this.setState({
      collapsedMenuDropdownOpen: false,
      productsDropdownOpen: !this.state.productsDropdownOpen
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js